/**
 * 域名访问统计工具
 * 用于记录域名访问情况
 */

/**
 * 记录域名访问
 * @param {string} domain - 域名
 * @param {string} path - 访问路径
 * @param {string} timestamp - 访问时间（可选，默认当前时间）
 */
export function recordDomainAccess(domain, path, timestamp = null) {
  try {
    // 构建请求数据
    const requestData = {
      domain: domain,
      path: path
    };

    // 如果提供了时间戳，则添加到请求数据中
    if (timestamp) {
      requestData.timestamp = timestamp;
    }

    // 静默发送请求，不显示任何错误信息
    fetch('https://s.alleatapp.com/api/domain-stats/record', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestData)
    })
    .then(response => {
      // 静默处理响应，不输出任何信息
      if (response.ok) {
        return response.json();
      }
    })
    .then(data => {
      // 静默处理成功响应，不输出任何信息
      return data;
    })
    .catch(error => {
      // 静默处理错误，不输出任何信息，不影响应用运行
      console.error('记录域名访问失败:', error);
      return null;
    });
  } catch (error) {
    // 静默处理任何异常，不输出任何信息
    console.error('记录域名访问失败:', error);
    return null;
  }
}

/**
 * 获取当前域名和路径
 * @returns {object} 包含domain和path的对象
 */
export function getCurrentDomainInfo() {
  const domain = window.location.hostname;
  const path = window.location.pathname;
  
  return {
    domain,
    path
  };
}

/**
 * 在应用启动时记录域名访问
 */
export function recordAppStartup() {
  try {
    const { domain, path } = getCurrentDomainInfo();
    
    // 静默记录应用启动访问，不输出任何信息
    recordDomainAccess(domain, path);
  } catch (error) {
    // 静默处理任何异常，不输出任何信息
  }
}
